import { Injectable } from '@angular/core';
import { GrowthBook } from "@growthbook/growthbook";
import { EnvironmentUtils } from '@haleo-frontend/utils';
import { lastValueFrom, ReplaySubject, take } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService {

    private growthBook: GrowthBook;
    private initialized: ReplaySubject<void>;

    public static flags = {
        zoomBrowserBasedIntegration: 'zoom-browser-based-integration',
        zoomNativeIntegration: 'zoom-native-integration',
    }

    constructor() {
        this.initialized = new ReplaySubject<void>(1);
    }

    async init() {

        if (EnvironmentUtils.env.growthBookKey) {

            this.growthBook = new GrowthBook({
                apiHost: 'https://cdn.growthbook.io',
                clientKey: EnvironmentUtils.env.growthBookKey,
                enableDevMode: true
            });

            await this.growthBook.loadFeatures({autoRefresh: true});
            this.initialized.next();
        }
    }

    async isOn(feature: string) {

        if (EnvironmentUtils.env.growthBookKey) {
            await lastValueFrom(this.initialized.pipe(take(1)));
            return this.growthBook.isOn(feature);
        } else {
            return false;
        }
    }
}
